document.addEventListener("DOMContentLoaded", () => {
  const images = document.querySelectorAll(".scroll-animation-images img");
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const img = entry.target;
      if (entry.isIntersecting) {
        img.classList.add("active");
        if (img.closest(".instagram-media-gallery")) {
          observer.unobserve(img);
        }
      } else {
        if (!img.closest(".instagram-media-gallery")) {
          img.classList.remove("active");
        }
      }
    });
  }, {
    threshold: 0.2,
  });
  images.forEach((img) => observer.observe(img));
});

